// LinkedIn company page URL. Uses a verified `linkedin` field when present,
// otherwise falls back to a best-effort slug derived from the startup name
// (which doesn't always match LinkedIn's slug, so some derived links may 404).
export const linkedinCompanyUrl = (startup) => {
  const explicit = (startup?.linkedin || '').trim();
  if (explicit) return explicit;
  const name = (startup?.name || '').trim();
  if (!name) return null;
  const slug = name
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/\b(inc|llc|corp|co|ltd|the)\b/g, ' ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug ? `https://www.linkedin.com/company/${slug}` : null;
};
